var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEclipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -8 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9996994%",
    y1: "1089.3962%",
    x2: "49.9996994%",
    y2: "-159.499661%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#473788",
    offset: "30.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2255",
    offset: "87.2%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9989479%",
    y1: "896.536635%",
    x2: "49.9989479%",
    y2: "-352.359227%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#473788",
    offset: "30.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2255",
    offset: "87.2%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9988435%",
    y1: "215.169856%",
    x2: "49.9988435%",
    y2: "-166.715419%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#473788",
    offset: "30.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2255",
    offset: "86.31%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M251.481071,152.819687 C246.245691,170.642011 236.536567,186.62 222.330265,200.732561 L221.705382,201.357553 C203.966028,218.982612 183.308033,229.550237 159.751763,233.105682 C153.799271,234.003242 147.671016,234.474286 141.345908,234.474286 C109.70396,234.474286 82.6458994,223.2372 60.1436046,200.732561 C46.0286993,186.615313 36.387537,170.642011 31.1919957,152.819687 L31.1919957,152.819687 Z M255.903257,126.17174 C255.692342,130.41746 255.253639,134.566371 254.617899,138.635555 L254.39873,139.989021 L28.2954287,139.989021 C27.6183913,135.937342 27.1387705,131.807836 26.8804839,127.583418 L26.8026187,126.17174 L255.903257,126.17174 Z M254.394043,99.5237922 C255.075299,103.57758 255.557239,107.707297 255.817656,111.930028 L255.896227,113.341073 L26.8026187,113.341073 C27.0114246,109.097462 27.4461206,104.948762 28.0776636,100.87789 L28.2954287,99.5237922 L254.394043,99.5237922 Z",
    fill: "#2C2255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.485758,86.6907818 C246.255065,68.8192446 236.543597,52.7709511 222.330265,38.5552752 C204.498567,20.7235776 183.690624,10.0254964 159.934556,6.42587921 C153.92582,5.51425739 147.736634,5.03618323 141.345908,5.03618323 C109.70396,5.03618323 82.6435559,16.2123386 60.1436046,38.5552752 C46.0240123,52.7709511 36.378163,68.8192446 31.1849652,86.6907818",
    fill: "#2C2255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9900619,119.759922 C19.9900619,59.2413568 65.44226,8.95686008 124.571129,0.112488039 C123.104097,0.0585875201 121.630035,0 120.148943,0 C53.795061,0 0,53.6192984 0,119.759922 C0,185.902888 53.7927175,239.519843 120.148943,239.519843 C121.634722,239.519843 123.108784,239.463599 124.580503,239.409699 C65.44226,230.565327 19.9900619,180.28083 19.9900619,119.759922 Z",
    fill: "#F7941E"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.110477, 99.069153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.201359,14.2695764 C155.817025,9.53336127 155.020235,4.91432119 153.829736,0.452295655 L2.65049941,0.452295655 C1.460001,4.91197769 0.660867227,9.53101777 0.276533095,14.2695764 L156.201359,14.2695764 Z",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.201359,27.1025868 L0.278876596,27.1025868 C0.663210728,31.8388019 1.4576575,36.457842 2.65049941,40.9198675 L153.83208,40.9198675 C155.022578,36.457842 155.817025,31.8388019 156.201359,27.1025868 Z",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2401179,98.9355735 C109.635998,98.9355735 136.698745,80.4383216 149.161483,53.7505345 L7.31875301,53.7505345 C19.7814903,80.4383216 46.8442376,98.9355735 78.2401179,98.9355735 Z",
    fill: "url(#linearGradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254.368264,139.986677 C253.597253,144.354963 252.587204,148.638882 251.335774,152.819687 L251.335774,152.819687 L31.1896522,152.819687 C29.9358793,148.636539 29.0617535,144.352619 28.2930852,139.986677 L28.2930852,139.986677 Z M255.701716,113.338729 C255.828265,115.548651 255.910288,117.767946 255.910288,120.005989 C255.910288,122.0753 255.849357,124.130551 255.741556,126.17174 L255.741556,126.17174 L26.7627792,126.17174 C26.6549782,124.130551 26.5940471,122.0753 26.5940471,120.005989 C26.5940471,117.767946 26.6760697,115.546307 26.8026187,113.338729 L26.8026187,113.338729 Z M250.585854,86.6907818 C251.858375,90.8715872 252.877798,95.1578502 253.669901,99.5237922 L253.669901,99.5237922 L28.2954287,99.5237922 C29.0851885,95.1555067 29.9077573,90.8692437 31.1826217,86.6907818 L31.1826217,86.6907818 Z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEclipse);
export default __webpack_public_path__ + "static/media/eclipse.1cf89261c60b4b903d10a23df66f5d2e.svg";
export { ForwardRef as ReactComponent };